'use client';

import { useCallback, useEffect, useRef } from 'react';

type NavSectionProps = {
  id: string;
  onSectionScrolledIntoView: (id: string | null) => void;
  children: React.ReactNode;
};

const TopOfPage = 100;
const AboveFold = 700;

const NavSection = ({ id, onSectionScrolledIntoView, children }: NavSectionProps) => {
  const containerEl = useRef<HTMLDivElement>(null);

  const handleScroll = useCallback(() => {
    const offsetTop = containerEl.current?.offsetTop || 0;

    const currentSection = window.location.hash.slice(1);

    if (Math.abs(window.scrollY - offsetTop) <= TopOfPage && currentSection !== id) {
      onSectionScrolledIntoView(id);
    } else if (window.scrollY < AboveFold && currentSection) {
      onSectionScrolledIntoView(null);
    }
  }, [id, onSectionScrolledIntoView]);

  useEffect(() => {
    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  });

  return (
    <div id={id} ref={containerEl}>
      {children}
    </div>
  );
};

export { NavSection as default };
export type { NavSectionProps };
